<style>

</style>

<template>



  <div class="wrapper wrapper-content">

    <div class="container-fluid">
  
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-md-offset-4 col-sm-offset-3">
        <div class="motto-head text-center">{{motto_message}}</div>
      </div>
      <!-- step1 -->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-md-offset-4 col-sm-offset-3">
        <div ref="step1" class="reg-box" v-if="step1_show">
          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>



            <div class="lotto-register text-center">
              <span>สมัครสมาชิก</span>
            </div>

            <p>&nbsp;</p>
            <!-- <p class="text-center">
              <router-link :to="{name: 'login'}" >
                <span class="badge badge-click-web text-center">
                  <i class="fa fa-arrow-circle-right" style="font-size:24px"></i> เข้าเว็บ คลิกเลย
                </span>
              </router-link>
            </p> -->

            <p>&nbsp;</p>
            <h5 class="text-primary text-white"><span class="badge badge-danger font-weight-light">STEP 1</span> ระบุเบอร์โทร</h5>
            <div class="widget-main">

              <form @submit.prevent="verifyPhoneNumber" class="form-login form-horizontal">

                <div class="form-group">
                  <label class="col-lg-12 col-sm-12 control-label"><i class="fa fa-mobile-phone" style="font-size:24px"></i> ลงทะเบียนเบอร์โทรศัพท์</label>
                </div>

                <div class="form-group">
                  <label class="col-lg-3 col-sm-12 control-label">THAILAND +66  <span class="flag-icon flag-icon-th"></span></label>
                  <div class="col-lg-8 col-sm-12">
                    <input type="text" name="user_mobile_phone" maxlength="10" @keyup="stopPhoneInput" class="form-control" @keypress="onlyNumber" placeholder="กรุณาใส่เบอร์โทรศัพท์" v-model="user_mobile_phone">
                  </div>
                </div>
                <hr>

                <div class="form-group">
                  <label class="col-lg-12 col-sm-12 control-label">กรุณาใส่หมายเลขโทรศัพท์เพื่อยืนยันตัวตน</label>
                </div>


                <div class="form-group" v-if="GG_CAPTCHA_ENABLE">
                  <label class="col-lg-3 col-sm-12 control-label">คลิกเพื่อยืนยันบุคคล</label>
                  <div class="col-lg-8 col-sm-12">
                    <vue-recaptcha
                      class='gg-captcha'
                      ref="recaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="sitekey">
                    </vue-recaptcha>
                  </div>
                </div>
                <hr  v-if="GG_CAPTCHA_ENABLE">
                <div class="form-group">
                  <div class="col-lg-offset-3 col-lg-8">
                    <button class="btn btn-block btn-lotto-primary mb-2" type="submit" :disabled="verify_phone_disabled">
                      <span><i class="fa fa-fw fa-arrow-circle-right"></i> ถัดไป</span>
                    </button>
                  </div>
                </div>
              </form>

            </div>

            <!-- <div class="contact-footer">
              <h5 class="text-primary">
                <a :href="line_contact" target="_blank"><span class="badge badge-danger font-weight-light"><i class="fa fa-phone"></i></span> ติดต่อเรา</a>
              </h5>
            </div> -->

          </div>

        </div> <!-- end reg-box -->
      </div>


      <!-- step2 -->
      <div class="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-sm-offset-2 col-lg-offset-4">
        <div ref="step2" class="reg-box" v-if="step2_show">

          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>

            <h5 class="text-primary text-white"><span class="badge badge-danger font-weight-light">STEP 2</span> สร้างบัญชีผู้ใช้</h5>

            
            <div class="widget-main">

              <form v-on:submit.prevent class="form-login form-horizontal">

                      <div class="form-group has-feedback">
                        <label for="pre_phone" class="col-lg-4 col-md-2 col-sm-12 control-label">Username : </label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.username.$error, 'form-group--success': !$v.credentials.username.$invalid && $v.credentials.username.$dirty }" >
                            <input
                                type="text"
                                class="form-control"
                                name="signup-form-username"
                                aria-describedby="Username"
                                v-model.trim="credentials.username"
                                @input="$v.credentials.username.$touch()"
                                placeholder="username (0-9, a-z)"
                            >
                            <div class="form-group__message" v-if="!$v.credentials.username.$minLength && $v.credentials.username.$error">Username must be at least 3 characters.</div>
                            <div class="form-group__message" v-if="$v.credentials.username.$error">Please enter your username.</div>
                        </div>
                      </div> 
                      
                      <div class="form-group has-feedback">
                        <label for="" class="col-lg-4 col-md-2 col-sm-12 control-label">รหัสผ่าน : </label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.password.$error, 'form-group--success': !$v.credentials.password.$invalid && $v.credentials.password.$dirty }" >
                            <input
                                type="password"
                                class="form-control"
                                name="signup-form-password"
                                aria-describedby="Password"
                                v-model.trim="credentials.password"
                                @input="$v.credentials.password.$touch()"
                                placeholder="password"
                            >
                            <div class="form-group__message" v-if="!$v.credentials.password.$minLength && $v.credentials.password.$error">Passwords must be at least 8 characters.</div>
                            <div class="form-group__message" v-if="$v.credentials.password.$error">Please enter a valid password.</div>
                        </div>
                      </div> 
                      
                      <div class="form-group has-feedback">
                        <label for="confirm_password" class="col-lg-4 col-md-2 col-sm-12 control-label">ยืนยันรหัสผ่าน : </label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.passwordConfirm.$error, 'form-group--success': !$v.credentials.passwordConfirm.$invalid && $v.credentials.passwordConfirm.$dirty }" >
                            <input
                                type="password"
                                class="form-control"
                                name="signup-form-passwordConfirm"
                                aria-describedby="Confirm Password"
                                v-model.trim="credentials.passwordConfirm"
                                @input="$v.credentials.passwordConfirm.$touch()"
                                placeholder="confirm password"
                            >
                            <div class="form-group__message" v-if="$v.credentials.passwordConfirm.$error">Password doesn't match.</div>
                        </div>
                      </div> 
                      
                      <div class="form-group">
                        <div class="col-lg-12">
                          <hr class="m-sm">
                        </div>
                      </div> 

                      <div class="form-group has-feedback">
                        <label class="col-lg-4 col-md-2 col-sm-12 control-label">ธนาคาร</label>

                        <div class="col-lg-8 col-md-10 col-sm-12">
                          <select class="selectpicker form-control" data-container="body" data-size="5" id="bank_id" name="bank_id" tabindex="-98" v-model="credentials.bank_id">
                              <option value="">กรุณาเลือกธนาคาร</option>
                              <option value="BBL" >ธ.กรุงเทพ</option>
                              <option value="KBANK" >ธ.กสิกรไทย</option>
                              <option value="KTB" >ธ.กรุงไทย</option>
                              <option value="TTB">ธ.ทหารไทยธนชาต</option>
                              <option value="SCB" >ธ.ไทยพาณิชย์</option>
                              <option value="BAY" >ธ.กรุงศรีอยุธยา</option>
                              <option value="KK" >ธ.เกียรตินาคิน</option>
                              <option value="CIMB" >ธ.ซีไอเอ็มบี</option>
                              <option value="TISCO" >ธ.ทิสโก้</option>
                              <option value="TBANK" >ธ.ธนชาต</option>
                              <!-- <option value="TMB">ธ.ทหารไทย</option> -->
                              <option value="UOB">ธ.ยูโอบี</option>
                              <option value="SC" >ธ.สแตนดาร์ดชาร์เตอร์ด (ไทย)</option>
                              <option value="TCD">ธ.ไทยเครดิตเพื่อรายย่อย</option>
                              <option value="LHB" >ธ.แลนด์ แอนด์ เฮ้าส์</option>
                              <option value="ICBC" >ธ.ไอซีบีซี (ไทย)</option>
                              <option value="BAAC" >ธ.เพื่อการเกษตรและสหกรณ์การเกษตร</option>
                              <option value="GSB">ธ.ออมสิน</option>
                              <option value="GHB">ธ.อาคารสงเคราะห์</option>
                              <option value="IBANK" >ธ.อิสลามแห่งประเทศไทย</option>
                              <option value="OTHER" >ธ.อื่นๆ</option>
                          </select>
                          <div class="form-group__message text-warning" v-if="credentials.bank_id == 'OTHER'">ท่านเลือกธนาคารที่ไม่มีอยู่ในรายการ เมื่อสมัครเสร็จเรียบร้อย กรุณาติดต่อเจ้าหน้าที่ของเรา เพื่อแจ้งข้อมูลธนาคารของท่านอีกครั้ง</div>
                          <div class="form-group__message" v-if="$v.credentials.bank_id.$error">Please enter a valid bank_id.</div>
                        </div>
                      </div>


                      <div class="form-group has-feedback">
                        <label class="col-lg-4 col-md-2 col-sm-12 control-label">ชื่อบัญชี</label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.bank_name.$error, 'form-group--success': !$v.credentials.bank_name.$invalid && $v.credentials.bank_name.$dirty }" >
                            <input
                                type="text"
                                class="form-control"
                                name="signup-form-bank_name"
                                aria-describedby="bank_name"
                                v-model.trim="credentials.bank_name"
                                @input="$v.credentials.bank_name.$touch()"
                                placeholder="ชื่อ นามสกุล หน้าสมุดบัญชี"
                            >
                            <div class="form-group__message" v-if="$v.credentials.bank_name.$error">Please enter your bank_name.</div>
                        </div>
                      </div> 
                              
                      <div class="form-group has-feedback">
                        <label class="col-lg-4 col-md-2 col-sm-12 control-label">เลขที่บัญชี</label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.bank_account.$error, 'form-group--success': !$v.credentials.bank_account.$invalid && $v.credentials.bank_account.$dirty }" >
                            <input
                                type="text"
                                class="form-control"
                                name="signup-form-bank_account"
                                aria-describedby="bank_account"
                                v-model.trim="credentials.bank_account"
                                @input="$v.credentials.bank_account.$touch()"
                                placeholder="ระบุเฉพาะตัวเลข"
                                maxlength="15"
                                @keypress="onlyNumber"
                            >
                            <div class="form-group__message" v-if="$v.credentials.bank_account.$error">Please enter your bank_account.</div>
                        </div>
                      </div> 

                      <!-- <div class="form-group has-feedback">
                        <label class="col-lg-4 col-md-2 col-sm-12 control-label">ยืนยันเลขที่บัญชี</label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.bank_accountConfirm.$error, 'form-group--success': !$v.credentials.bank_accountConfirm.$invalid && $v.credentials.bank_accountConfirm.$dirty }" >
                            <input
                                type="text"
                                class="form-control"
                                name="signup-form-bank_accountConfirm"
                                aria-describedby="bank_accountConfirm"
                                v-model.trim="credentials.bank_accountConfirm"
                                @input="$v.credentials.bank_accountConfirm.$touch()"
                                placeholder="ยืนยันเลขที่บัญชีอีกครั้ง"
                            >
                            <div class="form-group__message" v-if="$v.credentials.bank_accountConfirm.$error">Bank_account doesn't match.</div>
                        </div>
                      </div>  -->

                <!-- <hr> -->

                <div class="form-group has-feedback">
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <button type="button" class="btn btn-lotto-cancel btn-block mb-2" @click="cancelStep2()"> ยกเลิก</button>
                    </div>
                    <div class="col-sm-6">
                      <button class="btn btn-block btn-lotto-primary mb-2" @click="submit()">
                        <span v-if="pending"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></span>
                        <span v-else><i class="fa fa-fw fa-arrow-circle-right"></i> ถัดไป</span>
                      </button>
                    </div>
                  </div>
                </div> 

              </form>

            </div>

            <!-- <div class="contact-footer">
              <h5 class="text-primary">
                <a :href="line_contact" target="_blank"><span class="badge badge-danger font-weight-light"><i class="fa fa-phone"></i></span> ติดต่อเรา</a>
              </h5>
            </div> -->

          </div>

        </div> <!-- end reg-box -->
      </div>


      <!-- step3 -->
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-sm-offset-3 col-md-offset-3 col-lg-offset-4">
        <!-- <div ref="step3" class="reg-box"> -->
        <div ref="step3" class="reg-box" v-if="step3_show">

          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>

            <h5 class="text-primary text-white"><span class="badge badge-danger font-weight-light">STEP 3</span> สร้างบัญชีสำเร็จ</h5>
            <div class="widget-main">

              <div class="form-group">
                <div class="col-sm-12 control-label text-center" style="font-size: 44pt; color: #fff;"><i class="icofont-check-circled"></i></div>
                <div class="col-sm-12 control-label text-center" style="font-size: 14pt; color: #fff; margin-bottom:10px;">สมัครสมาชิกเรียบร้อย</div>

                <table class="table" style="border: 1px solid green; background-color: white; color: green;">
                  <thead><tr><th style="text-align: center">ข้อมูลสมาชิกของท่าน</th></tr></thead> 
                  <tbody>
                  <tr>
                    <td height="60" style="text-align: center"> ชื่อผู้ใช้: <span style="font-size: 14pt; color: #1e90ff;">{{ success_username }} </span> </td>
                  </tr>
                  <tr>
                    <td style="text-align: center; background-color: mediumseagreen; color: white;"> กรุณาเก็บข้อมูลของท่าน เพื่อใช้ในการเข้าเล่นครั้งต่อไป </td>
                  </tr>
                  </tbody>
                </table> 

              </div>

              <div class="form-group">
                <label class="col-sm-12 control-label text-center">ขั้นตอนต่อไป กรุณาเข้าสู่เหน้าหลัก เพื่อทำการ login</label>
              </div>

              <div class="form-group has-feedback">
                  <button type="button" class="btn btn-lotto-primary btn-block mb-2" @click="loginPage()"> เข้าสู่หน้าหลัก</button>
              </div>

            </div>
          </div>

        </div> <!-- end reg-box -->
      </div>


    </div>

<a href="#number-sets-modal" ref="openVerify" data-backdrop="static" data-keyboard="false" data-toggle="modal" class="btn btn-primary btn-block hide"></a>


<div id="number-sets-modal"  role="dialog" aria-hidden="true" class="modal inmodal fade">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="widget-modal-body">
 
      <div class="modal-body">
        <button type="button" ref="closeVerify" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 

        <div class="text-center">
          <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
        </div>

        <div class="otp-require text-center">
          <h6 class="modal-title">โปรดระบุรหัส OTP ที่ได้รับ</h6>
        </div>

        <div>

          <div>

            <form class="form-login form-horizontal">
              <div id="nbs-1" class="tab-pane tab-numbersets active">
                <div class="panel-body">

                  <div class="p-sm text-center">
                    <input type="text" name="verify_code" @keyup="stopCodeInput" class="form-control" :maxlength="otp_length" @keypress="onlyNumber" placeholder="กรุณาใส่เลข OTP" v-model="verify_code">
                  </div>

                  <div class="p-sm text-center">
                    <div class="row">
                      <div class="col-xs-6">
                        <button type="button" class="btn btn-lotto-renew btn-block btn-lg" @click="cancelVerify"> ยกเลิก </button>
                      </div> 
                      <div class="col-xs-6">
                        <button type="button" class="btn btn-lotto-primary btn-block btn-lg" @click="verifyCode" :disabled="verify_code_disabled"> ถัดไป</button>
                      </div>
                    </div>
                  </div> 

                </div>
              </div> 
            </form>

          </div>
        </div>

    </div>
  </div>
  </div>
  </div><!-- /#modal dialog -->
</div><!-- /#modal -->



    </div>
  </div><!-- /#page-wrapper -->

</template>






<script>
import { required, minLength, sameAs, numeric } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'


export default {
    components: { VueRecaptcha },
    name: 'newregister',
    data () {
        return {
            user_mobile_phone: '',
            request_id: '',
            verify_code: '',
            verify_code_disabled: true,
            verify_phone_disabled: true,
            success_username: '',

            step1_show: true,
            step2_show: false,
            step3_show: false,

            thai_country_code: '66',
            // sitekey: '6LeiNK4UAAAAAOx6FS3psemI3kfco8uJxOF8CoYP',
            sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // TEST SITE KEY

            GG_CAPTCHA_ENABLE: false,
            recaptchaVerified: false,
            pleaseTickRecaptchaMessage: '',
            recaptcha_response: '',

            line_contact: '',

            credentials: {
                username: '',
                password: '',
                passwordConfirm: '',
                parent_id: '',
                mobile_phone: '',
                bank_id: '',
                bank_name: '',
                bank_account: '',
                // bank_accountConfirm: '',
            },
            pending: false,
            motto_message: 'เว็บหวยออนไลน์ที่ดีที่สุด',

            otp_length: '',
        }
    },
    methods: {
        onSubmit: function () {
            this.$refs.invisibleRecaptcha.execute()
        },
        onVerify: function (response) {
            this.pleaseTickRecaptchaMessage = ''
            this.recaptchaVerified = true

            this.recaptcha_response = response
            //console.log('Verify: ' + response)
        },
        onExpired: function () {
            console.log('Expired')
        },
        resetRecaptcha () {
            this.$refs.recaptcha.reset() // Direct call reset method
        },
        stopPhoneInput(){
            if (this.user_mobile_phone.length == 10) { 
                this.verify_phone_disabled = false
            }
            else { 
                this.verify_phone_disabled = true
            }
        },

        async verifyPhoneNumber() {

            if ( this.GG_CAPTCHA_ENABLE && !this.recaptchaVerified) {
                this.pleaseTickRecaptchaMessage = 'กรุณาคลิกที่ checkbox เพื่อยืนยันว่าท่านไม่ใช่โปรแกรมอัตโนมัติ.'
                this.$toasted.error(this.pleaseTickRecaptchaMessage)

                return true // prevent form from submitting
            }

            if ( this.user_mobile_phone && this.phonenumber(this.user_mobile_phone) ) {

                let request_data = {
                    mobile_phone: this.user_mobile_phone,
                    recaptcha_response: this.recaptcha_response,
                }
                try {
                    let response = await this.$store.dispatch('user/checkMobile', request_data)
                    //console.log('verifyPhoneNumber', response)

                    this.otp_length = response.otp_length

                    if ( response.status ) {
                        //DUPLICATE_PHONENUM
                        this.$toasted.error('ไม่สามารถทำรายการได้ เบอร์โทรศัพท์นี้ถูกใช้ในการสมัครแล้ว')
                    }
                    else {

                        // remove prefix zero
                        let phonenum = this.user_mobile_phone.substring(1)
                        // add country code
                        phonenum = "" + this.thai_country_code + phonenum
 
                        let response = await this.$store.dispatch('user/requestPIN', phonenum)
                        //console.log('requestPIN', response)

                        if ( response.request_id ) {
                            this.request_id = response.request_id
                            this.$refs.openVerify.click()
                        }
                        else {
                            this.$toasted.error('Cannot request OTP, try again later. ' + response.error_text)
                        }

                        // //skip call API for testing
                        // console.log('phonenum', phonenum)
                        // this.$refs.openVerify.click()
                    }

                } catch (error) {

                    let error_obj = {}
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        error_obj = error.response.data
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        error_obj = error.request
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        error_obj = error.message
                    }
                    // console.log('error_obj', error_obj)

                    let error_msg = 'There was an error connecting to the server.'
                    if ( error_obj.message ) {
                        error_msg = error_obj.message
                    }
                    this.$toasted.error(error_msg)

                }

            }
            else {
                this.$toasted.error('เบอร์โทรศัพท์ไม่ถูกต้อง โปรดกรอกหมายเลขโทรศัพท์ 10 หลัก ด้วยรูปแบบดังนี้ 08XXXXXXXX ')
            }

        },

        phonenumber (phone) {
            let rgx = /^\d{10}$/g
            return phone.match(rgx)
        },

        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault()
            }
        },

        stopCodeInput(){
            //console.log('stopCodeInput', this.verify_code)
            if (this.verify_code.length == this.otp_length) { 
                this.verify_code_disabled = false
            }
            else { 
                this.verify_code_disabled = true
            }
            //console.log('stopCodeInput', this.verify_code_disabled)
        },

        async verifyCode() {

            if ( this.verify_code.length > 0 && this.otpcode(this.verify_code) ) {

                //console.log('verifyCode', this.user_mobile_phone, this.verify_code)

                let verify_data = {
                    request_id: this.request_id,
                    pin: this.verify_code
                }

                try {

                    let response = await this.$store.dispatch('user/verifyCode', verify_data)
                    if ( response.message == 'ERROR' ) {
                        this.$toasted.error('รหัส OTP ไม่ถูกต้อง.')
                    }
                    else {
                        // this.$refs.step1.style["display"] = "none"
                        // this.$refs.step2.style["display"] = "block"
                        this.step1_show = false
                        this.step2_show = true

                        this.$refs.closeVerify.click()
                    }

                    // //skip call API for testing
                    // this.step1_show = false
                    // this.step2_show = true
                    // console.log('verify_data', verify_data)
                    // this.$refs.closeVerify.click()


                } catch (error) {
                    let error_obj = {}
                    if (error.response) {
                        error_obj = error.response.data
                    } else if (error.request) {
                        error_obj = error.request
                    } else {
                        error_obj = error.message
                    }
                    let error_msg = 'There was an error connecting to the server.'
                    if ( error_obj.message ) {
                        error_msg = error_obj.message
                    }
                    this.$toasted.error(error_msg)
                    this.$refs.closeVerify.click()

                    this.$router.push({name: 'login'})
                }
                this.verify_code = ''

            }
            else {
                this.$toasted.error('หมายเลข OTP ไม่ถูกต้อง โปรดกรอกตัวเลข '+ this.otp_length +' หลักจาก SMS')
            }

        },

        otpcode (code) {
            // let rgx = /^\d{6}$/g
            let rgx = new RegExp(`^\\d{${this.otp_length}}$`, 'g')
            return code.match(rgx)
        },

        async cancelVerify() {
            this.$toasted.success('ยกเลิกเรียบร้อยแล้ว.')
            this.$refs.closeVerify.click()
            this.$router.push({name: 'login'})
        },

        async cancelVerifyNexmo() {
            //console.log('renewRequest', this.user_mobile_phone, this.request_id)

            try {
                let response = await this.$store.dispatch('user/cancelVerify', this.request_id)

                if ( response.error_text ) {
                    if ( response.status == 19 ) {
                        this.$toasted.error('ไม่สามารถยกเลิกได้ภายใน 30 วินาทีแรก กรุณารอสักครู่')
                    }
                    else {
                        this.$toasted.error('Cannot cancel verification. ' + response.error_text)
                    }
                    
                }
                else {
                    this.$toasted.success('ยกเลิกเรียบร้อยแล้ว.')
                    this.$refs.closeVerify.click()
                    this.$router.push({name: 'login'})
                }

            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let error_response = error.response.data
                if ( error_response ) {
                    error_msg = error_response.requestError.serviceException.text
                }
                this.$toasted.error(error_msg)
            }
        },

        cancelStep2(){
            //console.log('cancelStep2', this.verify_code)
            var r = confirm('คุณต้องการยกเลิกการสมัครสมาชิกใช่หรือไม่?')
            if (r == true) {
                this.$router.push({name: 'login'})
            }
        },

        async submit () {
            // console.log('submit', this.$v.$invalid)
            // console.log('submit V', this.$v)
            if (this.$v.$invalid) { this.$v.$touch(); return }

            this.pending = true

            const { username, password, passwordConfirm, parent_id, bank_id, bank_name, bank_account } = this.credentials
            const mobile_phone = this.user_mobile_phone

            const credentials = {
                username,
                password,
                passwordConfirm,
                parent_id,
                mobile_phone,
                bank_id,
                bank_name,
                bank_account,
                // bank_accountConfirm,
            }
            //console.log('credentials', credentials)

            try {
                await this.$store.dispatch('user/userSignup', credentials)
                this.$toasted.success('Successfully signed up.')
                //this.$toasted.success('Please wait a moment for the account to activate before you can login.')

                this.success_username = this.credentials.username

                this.credentials.username = ''
                this.credentials.password = ''
                this.credentials.passwordConfirm = ''
                this.credentials.mobile_phone = ''
                //this.credentials.parent_id = ''
                this.$v.$reset()
                // this.$router.push({name: 'login'})

                this.step1_show = false
                this.step2_show = false
                this.step3_show = true

            } catch (error) {

                let error_msg = 'Hmm, something you entered doesn\'t seem right.'
                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }
                this.$toasted.error(error_msg)

            } finally {
                this.pending = false
            }
        },

        async checkParentToken () {
            try {

                let parent_token = this.$route.params.parent_token
                //console.log('register parent_token', parent_token)

                if ( parent_token ) {

                    //const response = 1
                    const response = await this.$store.dispatch('affiliate/checkToken', { parent_token: parent_token})
                    //console.log('async initial checkParentToken', response)

                    if ( response ) {
                        //console.log('ok')
                        this.credentials.parent_id = response.id
                    }
                    else {
                        this.$toasted.error('ไม่เจอรหัสผู้แนะนำ')
                        this.$router.push({name: 'login',})
                    }

                }

            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'

                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }

                if (error_msg == 'DISABLED_REGISTER') {
                    error_msg = 'ยังไม่เปิดให้สมัครสมาชิก'
                }

                this.$toasted.error(error_msg)
                this.$router.push({name: 'login',})
            }
        },

        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
            } catch (error) {
                console.log('error', error)
            }
        },

        loginPage () {
            this.$router.push({name: 'login',})
        },

    },
    validations: {

        credentials: {
            bank_id: {
                required,
            },
            bank_name: {
                required,
            },
            bank_account: {
                required,
                numeric
            },
            // bank_accountConfirm: {
            //     sameAs: sameAs('bank_account')
            // },
            username: {
                //required,
                minLength: minLength(3)
            },
            password: {
                //required,
                minLength: minLength(8)
            },
            passwordConfirm: {
                sameAs: sameAs('password')
            }
        }
    },
    created () {
        let logo = (process.env.VUE_APP_SITE).toLowerCase() + '_logo.png'
        try {
            this.app_site_logo = require('@/assets/images/'+ logo)
        } catch (error) {
            this.app_site_logo = require('@/assets/images/'+ 'dummy_logo.png')
        }

        if ( process.env.VUE_APP_RECAPTCHA_ENABLE ) {
            this.GG_CAPTCHA_ENABLE = true
            this.sitekey = process.env.VUE_APP_RECAPTCHA_SITEKEY
        }

        this.checkParentToken()
        this.loadLineContact()
    },
    destroyed () {
    }
}
</script>

<style lang="scss" scoped>
  .gg-captcha {
    @media screen and (max-width: 320px) {
      transform:scale(0.77);
      -webkit-transform:scale(0.77);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }
    @media screen and (min-width: 321px) and (max-width: 375px) {
      transform:scale(0.92);
      -webkit-transform:scale(0.92);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }
    
    @media screen and (min-width: 1024px) and (max-width: 1400px) {
      transform:scale(0.8);
      -webkit-transform:scale(0.8);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }

  }

  .badge-danger {
    background-color: red;
    border-radius: 0px !important;
  }

  .badge-click-web {
    // background-color: red;
    // color: white;

    color: #212529;
    background-color: #ffc107;

    font-family: 'Kanit', sans-serif;
    font-size: 18px;
    line-height: 2;
    &:hover {
      color: #fff;
    }
  }

  .lotto-register {
      color: black;
      background-color: #dee3e6;
      font-size: 16pt;
      border-radius: 10px;
      border: 3px solid white;
      padding: 6px 12px;
      margin: auto;
      width: 70%;
  }

  .btn-lotto-primary {
      // color: black;
      // background-color: #4c8ae7;
      font-size: 14pt;
      border-radius: 10px;

      color: #212529;
      background-color: #ffc107;
      &:hover {
        color: #fff;
      }
  }

  .btn-lotto-renew {
      color: #fff;
      background-color: lightgrey;
      font-size: 14pt;
      border-radius: 10px;
  }

  .btn-lotto-cancel {
      color: #fff;
      background-color: dimgray;
      font-size: 14pt;
      border-radius: 10px;
  }

  .regbox-header {
      position: relative;
      min-height: 38px;
      // background: lightgrey;
      padding-left: 12px;
  }


  .regbox-footer {
    position: relative;
    min-height: 38px;
    // background: lightgrey;
    padding-left: 12px;
  }

  .widget-body {
    // background: #096c8c !important;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);
    // // border: 2px solid #4c8ae7;
    background: #2E7D32 !important;
    border: 2px solid white;
    border-radius: 10px;
  }

  .regbox-body {
    
    // background: #096c8c !important;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);
    background: #2E7D32 !important;
    font-family:tahoma;
    color: black !important;
    border-radius: 10px;
    padding: 5px;
  }

  .motto-head {
    min-height: 38px;
    // background: #add1dd;
    background: #2E7D32 !important;
    color: #ffc107;
    font-size: 16pt;
    padding: 5px;
  }

  .reg-box {
    margin: 10px auto;
  }
  
  .modal-header {
    // background-color: #096c8c;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);
    background: #2E7D32;
  }

  .modal-body {
    // background-color: #096c8c;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);

    background: #2E7D32;
    height: 60%; 
  }

  .modal { 
      position: fixed; 
      top: 3%; 
      right: 3%; 
      left: 3%; 
      width: auto; 
      margin: 10;
      padding: 3px; 
      border-radius: 10px;
  }

  .modal-content {
    background-clip: padding-box;
    background-color: #FFF;
    border: 3px solid white;
    border-radius: 10px;
    outline: 0 none;
    position: relative;
  }

  .otp-require {
      color: white;
      background-color: #545454;
      font-size: 16pt;
      border-radius: 10px;
      border: 3px solid white;
      padding: 6px 12px;
      margin: auto;
      width: 70%;
  }

  .widget-modal-body {
    background: rgba(2, 25, 80, 0.87);
    color: black;
    border: 0px solid black; 
  }

  .g-recaptcha {
    transform: scale(2);
    transform-origin: 0 0;
  }

  .widget-container {
    background-color: #096c8c !important;
    color: #fff;
  }

  .control-label {
    color: #fff;
  }
  label.control-label {
    text-align: left;
  }

  .contact-footer {
    background-color: #4c8ae7;
    margin-left: -5px;
    margin-right: -5px;
    margin-bottom: -5px;
    padding: 10px;

    a {
      color: #fff;
    }
  }

</style>
